import { useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import CommunityPostComponent from './CommunityPostComponent';

import { removePost } from '../actions';

import * as communitySelectors from '../selectors';

const CommunityPostContainer = (props) => {
  const {
    onRefetchPosts,
    removePost,
    currentPostId,
    closeModal,
    onUpdatePostStatus,
  } = props;

  const [showComments, setShowComments] = useState(false);
  const [isConfirmRemovePost, setIsConfirmRemovePost] = useState(false);

  const onToggleComments = () => setShowComments(!showComments);

  const onPostStatusUpdate = (status) => {
    onUpdatePostStatus(currentPostId, { status });
    closeModal();
  };

  const onRemovePost = async () => {
    const res = await removePost(currentPostId);
    closeModal();
    onRefetchPosts();
    return res;
  };

  return (
    <CommunityPostComponent
      {...props}
      onRemovePost={onRemovePost}
      showComments={showComments}
      onToggleComments={onToggleComments}
      isConfirmRemovePost={isConfirmRemovePost}
      setIsConfirmRemovePost={setIsConfirmRemovePost}
      onPostStatusUpdate={onPostStatusUpdate}
    />
  );
};

CommunityPostContainer.propTypes = {
  onRefetchPosts: PropTypes.func.isRequired,
  removePost: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  onUpdatePostStatus: PropTypes.func.isRequired,
  currentPostId: PropTypes.number.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  currentPost: communitySelectors.getPostById(state, ownProps),
});

const mapDispatchToProps = (dispatch) => ({
  removePost: (postId) => removePost(dispatch, postId),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CommunityPostContainer);
